/** Year of manufacture rule (mirrors the backend): a whole year from 1900 up to the current year. */
export const MIN_MANUFACTURE_YEAR = 1900;

export function validateManufactureYear(value: unknown, now: Date = new Date()): string | null {
  if (value === undefined || value === null || value === "") return null;          // optional field
  const n = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isInteger(n)) return "Year of manufacture must be a whole number.";
  if (n < MIN_MANUFACTURE_YEAR) return `Year of manufacture cannot be before ${MIN_MANUFACTURE_YEAR}.`;
  if (n > now.getFullYear()) return `Year of manufacture cannot be in the future (latest: ${now.getFullYear()}).`;
  return null;
}
